import { render, staticRenderFns } from "./TotalsSalesPurchasesReport.vue?vue&type=template&id=f885ea1c&scoped=true"
import script from "./TotalsSalesPurchasesReport.vue?vue&type=script&lang=js"
export * from "./TotalsSalesPurchasesReport.vue?vue&type=script&lang=js"
import style0 from "./TotalsSalesPurchasesReport.vue?vue&type=style&index=0&id=f885ea1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f885ea1c",
  null
  
)

export default component.exports